import PropTypes from 'prop-types';
import React from 'react';
import Input from '../Input';

var TableFilter = function TableFilter(_ref) {
  var id = _ref.id,
      column = _ref.column,
      filter = _ref.filter,
      _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Input, {
    size: "small",
    onChange: function onChange(event) {
      _onChange(event.target.value);
    },
    value: filter ? filter.value : '',
    "aria-label": "Filter by ".concat(column.Header),
    id: id ? "".concat(id, "_filter_").concat(column.Header) : "tablefilter_".concat(column.Header),
    autoComplete: false
  });
};

TableFilter.propTypes = {
  id: PropTypes.string,
  filter: PropTypes.object,
  onChange: PropTypes.func,
  column: PropTypes.object
};
TableFilter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableFilter",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "filter": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "column": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};
export default TableFilter;